<template>
  <div>
    <div class="row bg-grey pt-3">
      <div class="col-12">
        <h3 class="title-h3 border-bottom pb-3">
          <button type="button" class="btn btn-back" @click="$router.push('/customers')" />
          Back
        </h3>
      </div>
    </div>
    <div class="row pt-3">
      <div class="col-6 l-m-b-20">
        <h1>Requested Reviews</h1>
      </div>
      <div class="col-6 text-right">
        <button v-if="$_can('carriers.movers.invite')"
                class="btn btn-primary ld-ext-right"
                @click="resendReviewRequests"
                :class="loadingButton ? 'running' : ''"
                :disabled="buttonDisabled || !emailsResend.length"
        >
          RESEND REVIEW REQUESTS
          <div class="ld ld-ball ld-flip" />
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col-12 l-m-b-20">
        <div class="input-group search">
          <button type="button" class="btn input-group-btn" @click="clearSearch">
            <i :class="[q ? 'fa fa-remove' : 'fa fa-search']" />
          </button>
          <input class="form-control" type="text" v-model="q" @keyup="searchText($event)" placeholder="Search" />
        </div>
      </div>
      <div class="col-11 filters-field">
        <span>Filters:</span>
        <span v-if="filters.company" class="filter-item btn btn-filter">
          <span class="mod-icon-filter" @click="removeFilter('company')" />
          Company: {{ companies.find(el => el.id === filters.company).name }}</span>
        <span v-if="filters.used" class="filter-item btn btn-filter">
          <span class="mod-icon-filter" @click="removeFilter('used')" />
          Used: {{ filters.used === 1 ? 'Link Used' : 'Not Used' }}</span>
        <button class="btn btn-secondary add-filters" @click="showFilters = true">
          <i class="fa fa-plus filter-icon" />
        </button>
      </div>
    </div>
    <template v-if="!requestedReviews">
      <vue-content-loading :width="800" :height="450">
        <rect v-for="x in 15" :key="x" x="10" :y="15*x*1.4" rx="5" ry="5" width="720" height="6" />
      </vue-content-loading>
    </template>
    <template v-else>
      <table class="table m-table table-hover l-m-t-20">
        <thead class="m-table__heading">
          <tr>
            <th>
              Customer
            </th>
            <th>
              Email
            </th>
            <th>
              Company
            </th>
            <th>
              Used
            </th>
            <th />
          </tr>
        </thead>
        <tbody>
          <tr v-for="(review, index) in requestedReviews" :key="review.id">
            <td>{{ review.first_name }} {{ review.last_name }}</td>
            <td>{{ review.email }}</td>
            <td>{{ review.company.name }}</td>
            <td>{{ review.used ? 'Link Used' : 'Not Used' }}</td>
            <td class="py-0 align-baseline">
              <div class="check-field">
                <label :for="index" :class="{'check-open' : emailsResend.find((el) => el === review.id)}">
                  <span class="checkmark" />
                  <input type="checkbox" v-model="emailsResend" :value="review.id" :id="index" class="btn-check" />
                </label>
              </div>
            </td>
          </tr>
          <tr v-if="!requestedReviews.length">
            <td colspan="8" class="text-center">
              No results found
            </td>
          </tr>
        </tbody>
      </table>

      <div class="row">
        <div class="col-sm-6 mb-1 text-black-50"
             v-if="meta.total"
        >
          Showing {{ meta.from }} - {{ meta.to }} of {{ meta.total }}
        </div>
        <pagination class="col-sm-6 mb-1" :change-page="changePage" :meta="meta" />
      </div>
    </template>

    <!-- Filters -->
    <transition name="slide-fade">
      <div class="l-modal-mask" v-if="showFilters" @click.self="showFilters = false">
        <div v-if="showFilters" class="filters-side-modal flex flex-column">
          <div @click="showFilters = !showFilters" class="pointer">
            <h1 class="modal-h1 l-m-b-20"><span class="btn btn-back" />Add Filter</h1>
          </div>
          <div>
            <p>
              Filters are applied automatically. You can remove them one by one with minus button or with clear filters button.
            </p>
          </div>
          <div class="l-bg-white">
            <div class="row">
              <div class="col">
                <div class="row filters">
                  <div class="col-12">
                    <div class="select-wrap">
                      <label>Company</label>
                      <simple-select v-model="filters.company"
                                     :options="companies"
                                     placeholder="Select Company"
                                     @input="filter"
                      />
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="select-wrap">
                      <label>Used</label>
                      <simple-select v-model="filters.used"
                                     :options="usedOptions"
                                     @input="filter"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-auto">
            <div class="col">
              <button type="button" class="btn btn-not-active text-dark w-100" @click="clearFilters"
                      v-if="!(!filters.used && !filters.company)"
              >
                Clear filters
              </button>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import axios from 'axios';
import { mapState } from 'vuex';
import toastr from 'toastr';
import Pagination from '../Pagination';
import Errors from '../../classes/Errors';
import PhoneMask from '../../classes/PhoneMask';

export default {
  name: 'CustomersPending',
  components: {
    Pagination,
  },
  data() {
    return {
      filters: {
        company: '',
        used: '',
        sortKey: '',
        sortOrders: [],
      },
      requestedReviews: null,
      usedOptions: [{ id: 1, name: 'Link Used' }, { id: 0, name: 'Not Used' }],
      page: 1,
      meta: [],
      emailsResend: [],
      buttonDisabled: false,
      loadingButton: false,
      loadingButtonDelete: false,
      q: '',
      showFilters: false,
      phoneMask: new PhoneMask(),
      errors: new Errors(),
    };
  },
  computed: {
    ...mapState({
      companies: state => state.companies.companies.data,
    }),
  },
  created() {
    this.getRequestedReviews();
  },
  methods: {
    resendReviewRequests() {
      this.buttonDisabled = true;
      this.loadingButton = true;
      axios
        .put(`/customers/review-requests`, { request_ids: this.emailsResend })
        .then(() => {
          toastr.success('Successfully sent review request(s)');
          this.emailsResend = [];
        })
        .catch(err => {
          this.errors.record(err.response.data.error);
        })
        .finally(() => {
          this.loadingButton = false;
          this.buttonDisabled = false;
        });
    },
    getRequestedReviews() {
      axios
        .get(`/customers/review-requests`)
        .then(res => {
          this.requestedReviews = res.data.data;
          this.meta = res.data.meta;
        })
        .catch(err => {
          this.errors.record(err.response.data.error);
        })
        .finally(() => {
          this.loadingButton = false;
          this.buttonDisabled = false;
        });
    },
    getReviewRequestsFiltered() {
      axios
        .get(
          `/customers/review-requests?page=${this.page}&q=${encodeURIComponent(
            this.q,
          )}&company_id=${this.filters.company}&used=${this.filters.used}&sort=${
            this.filters.sortKey
          }&order=${this.filters.sortOrders[this.filters.sortKey] ? 'asc' : 'desc'}`,
        )
        .then(res => {
          this.requestedReviews = res.data.data;
          this.meta = res.data.meta;
        })
        .catch(err => {
          this.errors.record(err.response.data.error);
        })
        .finally(() => {
          this.loadingButton = false;
          this.buttonDisabled = false;
        });
    },
    searchText(e) {
      if (/^[a-zA-Z0-9]$/.test(e.key) || e.keyCode === 8 || e.keyCode === 13) {
        const vm = this;
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
          vm.getReviewRequestsFiltered();
        }, 500);
      }
    },
    clearSearch() {
      this.q = '';
      this.getReviewRequestsFiltered();
    },
    filter() {
      this.getReviewRequestsFiltered();
    },
    clearFilters() {
      this.filters = Object.assign(
        {
          company: '',
          used: '',
          sortKey: '',
          sortOrders: [],
        },
        {},
      );
      this.filter();
      this.showFilters = false;
    },
    sortBy(key) {
      this.$set(this.filters, 'sortKey', key);
      this.$set(this.filters.sortOrders, key, !this.filters.sortOrders[key]);
      this.getReviewRequestsFiltered();
    },
    changePage(pageNum) {
      this.page = pageNum;
      this.filter();
    },
    removeFilter(model) {
      this.filters[model] = '';
      this.filter();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/customers/CustomersPending.vue